import { configureStore } from "@reduxjs/toolkit";
import commonReducer from "./common/common.slice";
import authReducer from "./auth/auth.slice";
// APIs
import { commonApi } from "./common/common.api";
import { authApi } from "./auth/auth.api";
import { kraApi } from "./kra-management/kra.api";
import { kpiApi } from "./kpi-management/kpi.api";
import { employeeApi } from "./employee/employee.api";
import { teamApi } from "./team-management/team.api";
import { hrActionApi } from "./hr-action-management/hr-action.api";

export const store = configureStore({
  reducer: {
    [commonApi.reducerPath]: commonApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [kraApi.reducerPath]: kraApi.reducer,
    [teamApi.reducerPath]: teamApi.reducer,
    [hrActionApi.reducerPath]: hrActionApi.reducer,
    [kpiApi.reducerPath]: kpiApi.reducer,
    [employeeApi.reducerPath]: employeeApi.reducer,
    common: commonReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ["common.formValues.file"],
        ignoredActions: ["common/addFormValues"],
      },
    }).concat([
      commonApi.middleware,
      authApi.middleware,
      kraApi.middleware,
      teamApi.middleware,
      hrActionApi.middleware,
      kpiApi.middleware,
      employeeApi.middleware,
    ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
